import React from 'react';
import { PortableText, PortableTextReactComponents } from '@portabletext/react';

const serializers: Partial<PortableTextReactComponents> = {
  block: {
    h2: ({ children }) => {
      return <>{children}</>;
    },
    h3: ({ children }) => {
      return <>{children}</>;
    },
    h4: ({ children }) => {
      return <>{children}</>;
    },
  },
};

const PortableTable: React.FC<any> = ({ value }) => {
  return <PortableText value={value} components={serializers} />;
};

export default PortableTable;
